import type { Ref } from 'vue'
import type {
  CreateStoreDto,
  Store,
  StoreUpdate,
  UpdateApiKeyDto,
} from './types'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import { apiClient } from '@/shared/api'
import { isAuthenticated } from '@/shared/lib'

export const storeApi = {
  async createStore(storeData: CreateStoreDto): Promise<Store> {
    return apiClient.post<Store>('/store/create/', storeData)
  },

  async updateStore(storeData: StoreUpdate): Promise<Store> {
    return apiClient.patch<Store>('/store/update/', storeData)
  },

  async getStoreDetail(): Promise<Store> {
    return apiClient.get<Store>('/store/detail/')
  },

  async updateApiKey(apiKeyData: UpdateApiKeyDto): Promise<Store> {
    return apiClient.post<Store>('/store/update-apikey/', apiKeyData)
  },
}

// === Fetch My Stores ===

// Fetch My Stores Request
export function fetchMyStoresRequest() {
  return apiClient.get<Store[]>('/store/my-stores/')
}

// Fetch My Stores Query
export function useFetchMyStoresQuery() {
  return useQuery({
    queryKey: ['my-stores'],
    queryFn: fetchMyStoresRequest,
    enabled: isAuthenticated(), // Only run when user is authenticated
  })
}

// === Fetch Store Detail ===

// Fetch Store Detail Request
export function fetchStoreDetailRequest() {
  return apiClient.get<Store>('/store/detail/')
}

// Fetch Store Detail Query
export function useFetchStoreDetailQuery(
  enabled: boolean | Ref<boolean> = isAuthenticated(),
) {
  return useQuery({
    queryKey: ['store-detail'],
    queryFn: fetchStoreDetailRequest,
    enabled: computed(() => unref(enabled)),
  })
}
